import { call, put, select } from 'redux-saga/effects';

import { API } from '../../api';
import { loginSuccess, logout, logoutSuccess } from '../reducers/authSlice';
import { ModalType, showModal } from '../reducers/modalSlice';

export function* errorHandler({ error, recallCallback, callback }: { error: any; recallCallback: any; callback: any }) {
  console.log('OUR ERROR: ', error);
  const { status, title } = error?.response?.data;

  if (status === 403 && title === 'Access token expired') {
    yield refreshTokenSaga(recallCallback);
  } else if (status === 403 && title === 'Invalid token pair') {
    yield put(
      showModal({
        modalType: ModalType.LOG_OUT,
      }),
    );
  } else {
    yield callback();
  }
}

function* refreshTokenSaga(recallCallback: any) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);

    // @ts-ignore
    const response: any = yield call<any>(API.post, '/auth/refresh', { token });
    const newToken = response.data?.data?.access_token;

    yield put(loginSuccess(newToken));
    yield recallCallback();
  } catch (error: any) {
    console.log('REFRESH TOKEN ERROR', error);
    const { status, title } = error?.response?.data;
    if (status === 403 && title === 'Invalid token pair') {
      yield put(
        showModal({
          modalType: ModalType.LOG_OUT,
        }),
      );
      // yield put(logoutSuccess());
    }
    // alert(`${error?.response?.data?.detail}`);
  }
}
